import Lagerbuchungsart from '@/types/Lagerbuchungsart';

export default class Lagerbuchung {
    public lagerbuchung_id: number | null = null;
    public zeitpunkt: string | null = null;
    public lagerbuchungsart: string | null = Lagerbuchungsart.Default;
    public impfstoff_id: number | null = null;
    public impfstoffcharge_id: number | null = null;
    public anzahl: number | null = null;
    public patnr: number | null = null;
    public patimpfung_id: number | null = null;
    public impfstelle_id: number | null = null;
    public anmerkung: string | null = null;

    public impfstoff_impfung: string | null = null;
    public impfstoff_impfstoff: string | null = null;
    public impfstoffcharge_charge: string | null = null;
    public impfstoffcharge_impfstelle_id: number | null = null;
    public impfstelle_bezeichnung: number | null = null;
    public impfstelle_abkuerzung: number | null = null;
    public patient_titel: string | null = null;
    public patient_vorname: string | null = null;
    public patient_nachname: string | null = null;
    public patient_titel_nach_name: string | null = null;

    constructor(data?: Partial<Lagerbuchung>) {
        Object.assign(this, data);
    }
}
